import { render, staticRenderFns } from "./BoardListFaqLayout.vue?vue&type=template&id=9b498960&scoped=true&"
import script from "./BoardListFaqLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListFaqLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b498960",
  null
  
)

export default component.exports